module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Ga-Hc-Ib-Ja.86cb34b1.png";